var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapBasic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "mapBasic_svg__a",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mapBasic_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mapBasic_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#mapBasic_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94C0E0",
    mask: "url(#mapBasic_svg__b)",
    d: "M-2 22L22-2v24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6DFBB",
    mask: "url(#mapBasic_svg__b)",
    d: "M-2 22V-2h24z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 3H6a2.99 2.99 0 00-2.121.879A2.99 2.99 0 003 6v12c0 .828.336 1.578.879 2.121A2.99 2.99 0 006 21h12a2.99 2.99 0 002.121-.879A2.99 2.99 0 0021 18V6a2.99 2.99 0 00-.879-2.121A2.99 2.99 0 0018 3z",
    stroke: "#000",
    strokeWidth: 2
  }))));
}
export default __webpack_public_path__ + "static/media/b93a78df111e59f7b1ea1d3df36f4bc6-mapBasic.svg";
export { SvgMapBasic as ReactComponent };